module.exports = __webpack_public_path__ + "static/img/cjzp.e1bbff1b.png";